/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1AccountLoginPostRequest } from '../models';
// @ts-ignore
import type { ApiV1UserIdChangeEmailPut200Response } from '../models';
// @ts-ignore
import type { ApiV1UserIdChangeLangPutRequest } from '../models';
// @ts-ignore
import type { ApiV1UserIdChangePasswordPutRequest } from '../models';
// @ts-ignore
import type { ApiV1UserIdPutRequest } from '../models';
// @ts-ignore
import type { Message } from '../models';
/**
 * ProfileApi - axios parameter creator
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change email
         * @param {string} id User ID
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdChangeEmailPut: async (id: string, apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1UserIdChangeEmailPut', 'id', id)
            const localVarPath = `/api/v1/user/{id}/change-email`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1AccountLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Legacy requests sending only the language field re-couple the report language to the app language, clearing a previously set report-language override. Requests using the appLanguage field leave an explicit report-language override untouched.
         * @summary Change lang
         * @param {string} id User ID
         * @param {ApiV1UserIdChangeLangPutRequest} [apiV1UserIdChangeLangPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdChangeLangPut: async (id: string, apiV1UserIdChangeLangPutRequest?: ApiV1UserIdChangeLangPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1UserIdChangeLangPut', 'id', id)
            const localVarPath = `/api/v1/user/{id}/change-lang`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1UserIdChangeLangPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change user\'s password
         * @param {string} id User ID
         * @param {ApiV1UserIdChangePasswordPutRequest} [apiV1UserIdChangePasswordPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdChangePasswordPut: async (id: string, apiV1UserIdChangePasswordPutRequest?: ApiV1UserIdChangePasswordPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1UserIdChangePasswordPut', 'id', id)
            const localVarPath = `/api/v1/user/{id}/change-password`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1UserIdChangePasswordPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get profile info
         * @param {string} id User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1UserIdGet', 'id', id)
            const localVarPath = `/api/v1/user/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update profile info
         * @param {string} id User ID
         * @param {ApiV1UserIdPutRequest} [apiV1UserIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdPut: async (id: string, apiV1UserIdPutRequest?: ApiV1UserIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1UserIdPut', 'id', id)
            const localVarPath = `/api/v1/user/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1UserIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change email
         * @param {string} id User ID
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserIdChangeEmailPut(id: string, apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1UserIdChangeEmailPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserIdChangeEmailPut(id, apiV1AccountLoginPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1UserIdChangeEmailPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Legacy requests sending only the language field re-couple the report language to the app language, clearing a previously set report-language override. Requests using the appLanguage field leave an explicit report-language override untouched.
         * @summary Change lang
         * @param {string} id User ID
         * @param {ApiV1UserIdChangeLangPutRequest} [apiV1UserIdChangeLangPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserIdChangeLangPut(id: string, apiV1UserIdChangeLangPutRequest?: ApiV1UserIdChangeLangPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1UserIdChangeEmailPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserIdChangeLangPut(id, apiV1UserIdChangeLangPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1UserIdChangeLangPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change user\'s password
         * @param {string} id User ID
         * @param {ApiV1UserIdChangePasswordPutRequest} [apiV1UserIdChangePasswordPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserIdChangePasswordPut(id: string, apiV1UserIdChangePasswordPutRequest?: ApiV1UserIdChangePasswordPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserIdChangePasswordPut(id, apiV1UserIdChangePasswordPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1UserIdChangePasswordPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get profile info
         * @param {string} id User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1UserIdChangeEmailPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1UserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update profile info
         * @param {string} id User ID
         * @param {ApiV1UserIdPutRequest} [apiV1UserIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserIdPut(id: string, apiV1UserIdPutRequest?: ApiV1UserIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1UserIdChangeEmailPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserIdPut(id, apiV1UserIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1UserIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary Change email
         * @param {string} id User ID
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdChangeEmailPut(id: string, apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1UserIdChangeEmailPut200Response> {
            return localVarFp.apiV1UserIdChangeEmailPut(id, apiV1AccountLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Legacy requests sending only the language field re-couple the report language to the app language, clearing a previously set report-language override. Requests using the appLanguage field leave an explicit report-language override untouched.
         * @summary Change lang
         * @param {string} id User ID
         * @param {ApiV1UserIdChangeLangPutRequest} [apiV1UserIdChangeLangPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdChangeLangPut(id: string, apiV1UserIdChangeLangPutRequest?: ApiV1UserIdChangeLangPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1UserIdChangeEmailPut200Response> {
            return localVarFp.apiV1UserIdChangeLangPut(id, apiV1UserIdChangeLangPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change user\'s password
         * @param {string} id User ID
         * @param {ApiV1UserIdChangePasswordPutRequest} [apiV1UserIdChangePasswordPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdChangePasswordPut(id: string, apiV1UserIdChangePasswordPutRequest?: ApiV1UserIdChangePasswordPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
            return localVarFp.apiV1UserIdChangePasswordPut(id, apiV1UserIdChangePasswordPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get profile info
         * @param {string} id User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1UserIdChangeEmailPut200Response> {
            return localVarFp.apiV1UserIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update profile info
         * @param {string} id User ID
         * @param {ApiV1UserIdPutRequest} [apiV1UserIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserIdPut(id: string, apiV1UserIdPutRequest?: ApiV1UserIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1UserIdChangeEmailPut200Response> {
            return localVarFp.apiV1UserIdPut(id, apiV1UserIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @summary Change email
     * @param {string} id User ID
     * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1UserIdChangeEmailPut(id: string, apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1UserIdChangeEmailPut(id, apiV1AccountLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Legacy requests sending only the language field re-couple the report language to the app language, clearing a previously set report-language override. Requests using the appLanguage field leave an explicit report-language override untouched.
     * @summary Change lang
     * @param {string} id User ID
     * @param {ApiV1UserIdChangeLangPutRequest} [apiV1UserIdChangeLangPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1UserIdChangeLangPut(id: string, apiV1UserIdChangeLangPutRequest?: ApiV1UserIdChangeLangPutRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1UserIdChangeLangPut(id, apiV1UserIdChangeLangPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change user\'s password
     * @param {string} id User ID
     * @param {ApiV1UserIdChangePasswordPutRequest} [apiV1UserIdChangePasswordPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1UserIdChangePasswordPut(id: string, apiV1UserIdChangePasswordPutRequest?: ApiV1UserIdChangePasswordPutRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1UserIdChangePasswordPut(id, apiV1UserIdChangePasswordPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get profile info
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1UserIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1UserIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update profile info
     * @param {string} id User ID
     * @param {ApiV1UserIdPutRequest} [apiV1UserIdPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1UserIdPut(id: string, apiV1UserIdPutRequest?: ApiV1UserIdPutRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1UserIdPut(id, apiV1UserIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

